import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { Layout } from './components/Layout/Layout'
import { Overview } from './pages/Overview'
import { Funil } from './pages/Funil'
import { Corretores } from './pages/Corretores'
import { Leads } from './pages/Leads'
import { Empreendimentos } from './pages/Empreendimentos'
import { Produtividade } from './pages/Produtividade'
import { Metas } from './pages/Metas'
import { Intersetorial } from './pages/Intersetorial'
import { CadastroColaboradores } from './pages/CadastroColaboradores'
import { FilterProvider } from './contexts/FilterContext'
import { useAuthStore } from './store/authStore'

// Componente de Loading durante autenticação
function AuthLoading() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      gap: '16px',
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '4px solid #e2e8f0',
        borderTopColor: '#2196F3',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />
      <p style={{
        color: '#64748b',
        fontSize: '14px',
        margin: 0,
      }}>
        Verificando autenticação...
      </p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}

// Componente de acesso negado
function AccessDenied() {
  const { redirectToHub } = useAuthStore()

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      gap: '24px',
      padding: '24px',
      textAlign: 'center',
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        backgroundColor: '#fee2e2',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '40px',
      }}>
        🔒
      </div>
      <h1 style={{
        color: '#1e293b',
        fontSize: '24px',
        fontWeight: 600,
        margin: 0,
      }}>
        Acesso Não Autorizado
      </h1>
      <p style={{
        color: '#64748b',
        fontSize: '16px',
        margin: 0,
        maxWidth: '400px',
      }}>
        Você não tem permissão para acessar o Dashboard Comercial.
        Entre em contato com o administrador para solicitar acesso.
      </p>
      <button
        onClick={redirectToHub}
        style={{
          padding: '12px 24px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: 500,
          cursor: 'pointer',
        }}
      >
        Voltar ao Hub
      </button>
    </div>
  )
}

function App() {
  const { isAuthenticated, isLoading, isInitialized, initialize, redirectToHub } = useAuthStore()

  // Inicializa a autenticação ao carregar o app
  useEffect(() => {
    initialize()
  }, [initialize])

  // Enquanto está carregando, mostra loading
  if (isLoading || !isInitialized) {
    return <AuthLoading />
  }

  // Se não autenticado após inicialização, redireciona para o Hub
  if (!isAuthenticated) {
    // Dá um tempo para mostrar a mensagem antes de redirecionar
    setTimeout(() => {
      redirectToHub()
    }, 100)
    return <AuthLoading />
  }

  return (
    <FilterProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#1e293b',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
          },
          success: {
            iconTheme: {
              primary: '#22c55e',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Layout>
          <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/funil" element={<Funil />} />
            <Route path="/corretores" element={<Corretores />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/empreendimentos" element={<Empreendimentos />} />
            <Route path="/produtividade" element={<Produtividade />} />
            <Route path="/metas" element={<Metas />} />
            <Route path="/intersetorial" element={<Intersetorial />} />
            <Route path="/cadastro-colaboradores" element={<CadastroColaboradores />} />
          </Routes>
        </Layout>
      </Router>
    </FilterProvider>
  )
}

export default App
